import { render, staticRenderFns } from "./SelectorLabels.vue?vue&type=template&id=d8e1affc&scoped=true&"
import script from "./SelectorLabels.vue?vue&type=script&lang=js&"
export * from "./SelectorLabels.vue?vue&type=script&lang=js&"
import style0 from "./SelectorLabels.vue?vue&type=style&index=0&id=d8e1affc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e1affc",
  null
  
)

export default component.exports